/**
 * 학습 행동 감사 로그를 남기는 훅 (객관식 챕터용).
 *
 * 화면에서 문제를 풀거나 이탈하는 등 이벤트가 발생할 때마다 `logEvent`를 호출하면
 * 즉시 서버로 보내지 않고 Recoil 큐(`auditLogQueueState`)에 쌓아 둔다.
 * 네트워크가 끊긴 상태에서도 이벤트 순서를 잃지 않고, 나중에 큐를 한 번에 동기화하는
 * 별도 컴포넌트(AuditLogSync 계열)가 서버로 전송한다.
 *
 * 서술형(essay) 챕터는 같은 큐를 재사용하는 `useEssayAuditLogger`를 대신 쓴다.
 */
import { useRecoilState, useRecoilValue } from "recoil";
import { auditLogQueueState, userState } from "@/recoil/atom";
import { AuditLogPayload } from "@/types/auditLogProps";

export const useAuditLogger = () => {
  const [queue, setQueue] = useRecoilState(auditLogQueueState);
  const user = useRecoilValue(userState);

  /** 이벤트를 서버로 바로 보내지 않고 큐에 적재한다. userId는 이 함수가 채운다. */
  const logEvent = (payload: Omit<AuditLogPayload, "userId">) => {
    // 1. 유저 ID 주입 (로그인 되어있지 않으면 0이나 무시?)
    const userId = user?.id || Number(sessionStorage.getItem("userId")) || 0;
    
    // 2. 일단 무조건 큐에 추가 (순서 보장)
    setQueue((prev) => [...prev, { ...payload, userId }]);
  };

  return { logEvent };
};
